import React, { useEffect, useRef, useState } from 'react';

/** Keep the SDK outside React's DOM. Always dispose observers, timers and requests. */
export const AdRail: React.FC<{ suspended?: boolean }> = ({ suspended = false }) => {
  const hostRef = useRef<HTMLElement>(null);
  const [unavailable, setUnavailable] = useState(false);
  const config = window.PicPlayerAdsConfig;
  const enabled = config?.enabled === true;

  useEffect(() => {
    const host = hostRef.current;
    if (!host || !enabled || suspended) return;
    host.hidden = false;
    setUnavailable(false);
    try {
      if (!window.PicPlayerAds) throw new Error('The local advertising SDK is unavailable.');
      const controller = window.PicPlayerAds.mount({
        element: host,
        appId: 'storyboardsmith',
        managerUrl: config?.managerUrl || 'https://ads.picplayer.com',
        minViewportWidth: 1280,
        privacyUrl: config?.privacyUrl || './privacy.html',
        cssUrl: new URL('./ads/rail.css', document.baseURI).href,
      });
      return () => controller.destroy();
    } catch {
      setUnavailable(true);
    }
  }, [enabled, suspended, config]);

  if (!enabled || suspended) return null;
  return <aside ref={hostRef} className="ss-ad-rail" data-ad-app="storyboardsmith" data-ad-manager={config?.managerUrl || 'https://ads.picplayer.com'} aria-label="Sponsored advertisements">
    {unavailable && <div className="ss-ad-fallback"><small>SPONSORED</small><h2>A little space.<br />More possibility.</h2><p>Keep creating. Advertising is currently unavailable.</p><button type="button" onClick={() => document.dispatchEvent(new CustomEvent('picplayer:ad-preferences', { cancelable: true }))}>Ad choices</button></div>}
  </aside>;
};
